import styled from 'styled-components';

export const MainDetailsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;
  padding-top: 10px;
`;

export const DetailsItem = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 10px ;
  div {
    width: fit-content;
  }
`;
